/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Conflict_Reason_MaybeInputs */

const cs_ebr_conflict_reason_maybe = /** @type {(inputs: Ebr_Conflict_Reason_MaybeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Možná ruční úprava`)
};

const en_ebr_conflict_reason_maybe = /** @type {(inputs: Ebr_Conflict_Reason_MaybeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Possible manual edit`)
};

/**
* | output |
* | --- |
* | "Possible manual edit" |
*
* @param {Ebr_Conflict_Reason_MaybeInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_conflict_reason_maybe = /** @type {((inputs?: Ebr_Conflict_Reason_MaybeInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Conflict_Reason_MaybeInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_conflict_reason_maybe(inputs)
	return cs_ebr_conflict_reason_maybe(inputs)
});